<template>
  <div class="replacement-customer">

    <h5 v-if="replacedCustomer">Removido</h5>

    <CustomerCard :show-edit-button="false" :customer="customers[oldWinner.customerId]"></CustomerCard>

    <div v-if="replacedCustomer">
      <h5>Novo ganhador</h5>

      <CustomerCard :show-edit-button="false" :customer="customers[newWinner.customerId]"></CustomerCard>

      <div class="row">
        <div class="col-xs-12 text-center">

          <router-link v-if="newWinner.stockId" :to="{name: 'tickets.documentation', params: {id: newWinner._id }}">
            <a title="Enviar documentação" class="btn btn-fill btn-icon btn-info"><i class="ti-upload"></i></a>
          </router-link>

          <button v-if="newWinner.stockId" title="Imprimir documentação" class="btn btn-fill btn-icon btn-info" @click="handleDocumentsPrint(0, newWinner)"><i class="ti-files"></i></button>

          <button class="btn btn-fill btn-icon btn-info" title="Imprimir ticket" @click="printTicket()"><i class="ti-receipt"></i></button>

        </div>
      </div>
    </div>

    <div v-if="!replacedCustomer">
      <div v-if="automatic">
        <div class="row text-right">
          <div class="col-xs-12">

            <button class="btn btn-fill btn-primary btn-wd" @click="handleReplacement(true)"> Substituir Aleatoriamente </button>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <form action="#">
            <input type="text" v-model.trim="filter" @keyup.enter="filtering()">
            <button type="button" class="btn btn-fill btn-primary btn-wd" @click="filtering()"> Buscar </button>
          </form>
        </div>
      </div>

      <div class="row" v-if="!automatic">
        <div class="col-xs-12">
          <el-table :data="dataTable">
            <el-table-column property="holder" label="Nome" width="150">
              <template slot-scope="props">{{ customers[props.row.customerId].holder }}</template>
            </el-table-column>
            <el-table-column property="uc" label="UC" width="200">
              <template slot-scope="props">{{ customers[props.row.customerId].uc }}</template>
            </el-table-column>
            <el-table-column property="cpf" label="CPF">
              <template slot-scope="props">{{ customers[props.row.customerId].cpf }}</template>
            </el-table-column>
            <el-table-column property="_id" label="Ações">
              <template slot-scope="scope">
                <button class="btn btn-fill btn-primary btn-wd" @click="handleReplacement(false, scope.row)"> Substituir </button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import CustomerCard from 'src/pages/Customers/CustomerCard'
  import { Table } from 'element-ui'
  import Vue from 'vue'
  Vue.use(Table)
  export default {
    name: 'replacement-customer',

    props: [ 'oldWinner', 'tickets', 'automatic', 'replacementCustomerSync', 'customers' ],

    components: {
      CustomerCard
    },

    data () {
      return {
        replacedCustomer: false,
        newWinner: { address: {} },
        filter: '',
        dataTable: []
      }
    },

    computed: {
      ticketsNotWinner () {
        return this.tickets.filter(obj => {
          let invalid = obj.winner || !obj.eligible || !this.customers[obj.customerId] || (this.customers[obj.customerId] && this.customers[obj.customerId].contemplated)
          if (this.isEventRanking) {
            invalid = invalid || !this.surveyValid(this.isTicketSurveyed(obj)) || obj.hasOwnProperty('canceledAt')
          }
          return !invalid
        })
      }
    },

    methods: {
      ...mapActions('tickets', [ 'replaceTicketWinner' ]),

      filtering () {
        if (this.filter === '') {
          this.dataTable = this.ticketsNotWinner
        } else {
          this.dataTable = this.ticketsNotWinner.filter(item => {
            return this.customers[item.customerId] &&
              (this.customers[item.customerId].uc.indexOf(this.filter) !== -1 ||
              this.customers[item.customerId].cpf.indexOf(this.filter) !== -1 ||
              this.customers[item.customerId].holder.indexOf(this.filter) !== -1) ||
              this.customers[item.customerId].holder.indexOf(this.filter.toUpperCase()) !== -1 ||
              this.customers[item.customerId].holder.indexOf(this.filter.toLowerCase()) !== -1
          })
        }
      },

      handleReplacement (random, row) {
        if (random) {
          let idx = Math.floor(Math.random() * this.ticketsNotWinner.length)
          this.newWinner = Object.assign({}, this.ticketsNotWinner[idx])
        } else {
          this.newWinner = Object.assign({}, this.tickets.find(item => row._id === item._id))
        }

        let obj = { oldWinner: this.oldWinner, newWinner: this.newWinner }

        this.replaceTicketWinner(obj).then(() => {
          this.replacedCustomer = true
          this.$notify({
            message: 'Cliente substituído com sucesso',
            type: 'success'
          })
        }).catch(err => {
          console.log(err)
          this.$notify({
            message: 'Ocorreu algum problema com a substituição.',
            type: 'error'
          })
        })
      },

      printTicket () {
        this.$emit('handleTicketPrint', 0, this.newWinner)
      }
    },

    mounted () {
      this.dataTable = this.ticketsNotWinner
    },

    watch: {
      oldWinner: function () {
        this.$nextTick(() => {
          this.replacedCustomer = false
          this.newWinner = { address: {} }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/ReplacementCustomer.vue